var map = {
	"./HP_minus.mp3": "./src/sound/HP_minus.mp3",
	"./HP_plus.mp3": "./src/sound/HP_plus.mp3",
	"./Initiative.mp3": "./src/sound/Initiative.mp3",
	"./Magic.mp3": "./src/sound/Magic.mp3",
	"./Shield.mp3": "./src/sound/Shield.mp3",
	"./Sword.mp3": "./src/sound/Sword.mp3",
	"./Vampire.mp3": "./src/sound/Vampire.mp3",
	"./Werewolf.mp3": "./src/sound/Werewolf.mp3",
	"./coin.mp3": "./src/sound/coin.mp3",
	"./dice1.mp3": "./src/sound/dice1.mp3",
	"./dice2.mp3": "./src/sound/dice2.mp3",
	"./dice3.mp3": "./src/sound/dice3.mp3",
	"./pouch_close.mp3": "./src/sound/pouch_close.mp3",
	"./pouch_open.mp3": "./src/sound/pouch_open.mp3",
	"./state0.wav": "./src/sound/state0.wav",
	"./state1.wav": "./src/sound/state1.wav"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/sound sync recursive ^\\.\\/.*$";